module.exports = __webpack_public_path__ + "static/img/hagens-akeri-logo.2a6922f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hagens-akeri-logo.png
// module id = 8KmY
// module chunks = 1